import React from 'react'
import HostTravelers from "../../Components/Hosts/HostTravelers"
import NavBar from "../../Components/Navbar/Navbar"
const Hosts = () => {
    return (
        <>
            <NavBar></NavBar>
            <HostTravelers></HostTravelers>
        </>
    )
}

export default Hosts
